"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@rmwc/icon/styles");
require("@rmwc/ripple/styles");
require("@material/icon-button/dist/mdc.icon-button.css");
